import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/layouts/Header";
import axiosClient from "../../api/axiosClient";
import { connectCalendarWithCode, getCalendarStatus, getCalendars } from "../../api/calendar";

const CalendarConnectedPage = () => {
    const navigate = useNavigate();
    const [calendars, setCalendars] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const returnTo = sessionStorage.getItem('calendarConnectReturnTo');

        if (code && returnTo) {
            sessionStorage.removeItem('calendarConnectReturnTo');
            connectCalendarWithCode(code)
                .then(() => Promise.all([getCalendarStatus(), getCalendars()]))
                .then(([상태, 목록]) => {
                    navigate(returnTo, {
                        replace: true,
                        state: {
                            calendarStatus: 상태,
                            calendars: 목록 ?? [],
                        },
                    });
                })
                .catch(() => {
                    navigate(returnTo, { replace: true });
                });
            return;
        }

        const fetchCalendars = async () => {
            try {
                const res = await axiosClient.get('/calendar/calendars');
                setCalendars(res.data.data.calendars);
            } catch {
            } finally {
                setLoading(false);
            }
        };
        fetchCalendars();
    }, [navigate]);

    return (
        <div
            style={{
                width: '100dvw',
                minHeight: '100dvh',
                background: '#000000'
            }}
        >
            <Header />

            <div
                style={{
                    width: '100%',
                    minHeight: 'inherit',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                    padding: '120px 40px 40px',
                    boxSizing: 'border-box',
                }}
            >
                <span
                    style={{
                        fontFamily: 'Pretendard',
                        fontSize: '20px',
                        fontWeight: '600',
                        color: '#FFFFFF',
                    }}
                >
                    구글 캘린더 연동이 완료되었습니다
                </span>

                {loading ? (
                    <span style={{ fontFamily: 'Pretendard', fontSize: '14px', color: '#A0A0A0' }}>
                        캘린더 목록을 불러오는 중...
                    </span>
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px',
                            width: '100%',
                            maxWidth: '480px',
                        }}
                    >
                        {calendars.map((calendar) => (
                            <div
                                key={calendar.id}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    padding: '12px 16px',
                                    borderRadius: '8px',
                                    background: '#1F2229',
                                    border: '1px solid #2E3038',
                                }}
                            >
                                <div
                                    style={{
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        background: calendar.background_color || '#487BFD',
                                        flexShrink: 0,
                                    }}
                                />
                                <span
                                    style={{
                                        fontFamily: 'Pretendard',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#FFFFFF',
                                    }}
                                >
                                    {calendar.title}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CalendarConnectedPage;
